import { makeStyles } from '@material-ui/core';
import * as React from 'react';
import { useIntl } from 'react-intl';
import { Heading4, Heading7, Paragraph } from '../elements/index';
import { Modal } from '../modal/Modal';
import ScrollView from '../scrollview/ScrollView';
// removed import of scss-style
const generally = [
    'preamble.terms-of-delivery-generally-1',
    'preamble.terms-of-delivery-generally-2',
    'preamble.terms-of-delivery-generally-3'
];
const usage = [
    'preamble-terms-of-delivery-usage-1',
    'preamble-terms-of-delivery-usage-2',
    'preamble-terms-of-delivery-usage-3',
    'preamble-terms-of-delivery-usage-4',
    'preamble-terms-of-delivery-usage-5',
    'preamble-terms-of-delivery-usage-6',
    'preamble-terms-of-delivery-usage-7',
    'preamble-terms-of-delivery-usage-8',
    'preamble-terms-of-delivery-usage-9'
];
const implementation = [
    'preamble-terms-of-delivery-assignment-implementation-1',
    'preamble-terms-of-delivery-assignment-implementation-2',
    'preamble-terms-of-delivery-assignment-implementation-3',
    'preamble-terms-of-delivery-assignment-implementation-4',
    'preamble-terms-of-delivery-assignment-implementation-5',
    'preamble-terms-of-delivery-assignment-implementation-6',
    'preamble-terms-of-delivery-assignment-implementation-7',
    'preamble-terms-of-delivery-assignment-implementation-8',
    'preamble-terms-of-delivery-assignment-implementation-9',
    'preamble-terms-of-delivery-assignment-implementation-10',
    'preamble-terms-of-delivery-assignment-implementation-11',
];
const personalData = [
    'preamble-terms-of-delivery-personal-data-1',
    'preamble-terms-of-delivery-personal-data-1a',
    'preamble-terms-of-delivery-personal-data-1b',
    'preamble-terms-of-delivery-personal-data-1c',
    'preamble-terms-of-delivery-personal-data-2',
    'preamble-terms-of-delivery-personal-data-3',
    'preamble-terms-of-delivery-personal-data-4',
    'preamble-terms-of-delivery-personal-data-5'
];
const responsibilities = [
    'preamble-terms-of-delivery-responsibilities-1',
    'preamble-terms-of-delivery-responsibilities-2',
];
const jurisdictions = [
    'preamble-terms-of-delivery-jurisdiction-1',
    'preamble-terms-of-delivery-jurisdiction-2',
];
const useStyles = makeStyles({
    header: {
        marginTop: '3rem'
    },
    paragraph: {
        marginTop: '1rem'
    }
});
const TermsOfDeliveryModal = ({ onCloseClick }) => {
    const intl = useIntl();
    const style = useStyles();
    return (React.createElement(Modal, { className: 'TermsOfDeliveryModal', onCloseClick: onCloseClick, large: true },
        React.createElement("div", { className: 'TermsOfDeliveryModal__Inner' },
            React.createElement(Heading4, null, intl.formatMessage({ id: 'label.terms-of-delivery' })),
            React.createElement(ScrollView, null,
                React.createElement("div", { className: 'TermsOfDeliveryModal__ScrollingContent' },
                    React.createElement(Heading7, { className: style.header }, intl.formatMessage({ id: 'label.terms-of-delivery-generally' })),
                    generally.map((label, index) => (React.createElement(Paragraph, { key: index, className: style.paragraph }, intl.formatMessage({ id: label })))),
                    React.createElement(Heading7, { className: style.header }, intl.formatMessage({ id: 'label.terms-of-delivery-rights' })),
                    React.createElement(Paragraph, { className: style.paragraph }, intl.formatMessage({ id: 'preamble-terms-of-delivery-rights' })),
                    React.createElement(Heading7, { className: style.header }, intl.formatMessage({
                        id: 'label.terms-of-delivery-assignment-implementation'
                    })),
                    implementation.map((label, index) => (React.createElement(Paragraph, { key: index, className: style.paragraph }, intl.formatMessage({ id: label })))),
                    React.createElement(Heading7, { className: style.header }, intl.formatMessage({ id: 'label.terms-of-delivery-usage' })),
                    usage.map((label, index) => (React.createElement(Paragraph, { key: index, className: style.paragraph }, intl.formatMessage({ id: label })))),
                    React.createElement(Heading7, { className: style.header }, intl.formatMessage({
                        id: 'label.terms-of-delivery-personal-data'
                    })),
                    personalData.map((label, index) => (React.createElement(Paragraph, { key: index, className: style.paragraph }, intl.formatMessage({ id: label })))),
                    React.createElement(Heading7, { className: style.header }, intl.formatMessage({ id: 'label.terms-of-delivery-secrecy' })),
                    React.createElement(Paragraph, { className: style.paragraph }, intl.formatMessage({ id: 'preamble-terms-of-delivery-secrecy' })),
                    React.createElement(Heading7, { className: style.header }, intl.formatMessage({ id: 'label.terms-of-delivery-flaws' })),
                    React.createElement(Paragraph, { className: style.paragraph }, intl.formatMessage({ id: 'preamble-terms-of-delivery-flaws' })),
                    React.createElement(Heading7, { className: style.header }, intl.formatMessage({ id: 'label.terms-of-delivery-responsibilities' })),
                    responsibilities.map((label, index) => (React.createElement(Paragraph, { key: index, className: style.paragraph }, intl.formatMessage({ id: label })))),
                    React.createElement(Heading7, { className: style.header }, intl.formatMessage({
                        id: 'label.terms-of-delivery-force-majeure'
                    })),
                    React.createElement(Paragraph, { className: style.paragraph }, intl.formatMessage({
                        id: 'preamble-terms-of-delivery-force-majeure'
                    })),
                    React.createElement(Heading7, { className: style.header }, intl.formatMessage({
                        id: 'label.terms-of-delivery-jurisdiction'
                    })),
                    jurisdictions.map((label, index) => (React.createElement(Paragraph, { key: index, className: style.paragraph }, intl.formatMessage({ id: label })))))))));
};
export default TermsOfDeliveryModal;
